import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=b1f92578&scoped=true&"
import script from "./SummaryCard.vue?vue&type=script&lang=ts&"
export * from "./SummaryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f92578",
  null
  
)

export default component.exports